import signals from 'signals';

export default class Client {
  constructor() {
    this._notAuthorizedError = new signals.Signal();
    this._sessionError = new signals.Signal();
  }

  get notAuthorizedError() {
    return this._notAuthorizedError;
  }

  get sessionError() {
    return this._sessionError;
  }

  authorize(application, token) {
  }

  deauthorize(application) {
  }
}
